import React from "react";
import { Col, Row } from "antd";
import DashbordCard from "../Dashboard/DashbordCard";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import audit from "../../assests/images/SVG/audit-dash.svg";
import report from "../../assests/images/SVG/report-img.svg";
import constants from "../../constants/constants";

const { ROLES } = constants;
const { HUB_ADMIN, HO_ADMIN, DEVELOPER } = ROLES;

const cards = [
  {
    key: "mark-lost-damage",
    title: "Mark Lost / Damage/ On Hold",
    route: "/mark-lost-damage",
    icon: audit,
  },
  {
    key: "mark-undelivered",
    title: "Mark Undelivered",
    route: "/mark-undelivered",
    icon: report,
    allowedRoles: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
];

function ShipmentStatus() {
  const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
  const userRoles = userinfo?.roles || [];
  const visibleCards = cards.filter(
    (item) =>
      !item.allowedRoles ||
      item.allowedRoles.some((role) => userRoles.includes(role))
  );

  return (
    <div className="dashboard-container" style={{ paddingTop: "20px" }}>
      <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 16, paddingLeft: "5px" }}>
        Shipment Status
      </div>

      <Row gutter={[32, 32]} className="dashboard-container-row">
        <Col xl={16} lg={16} md={24} sm={24} xs={24} className="dashboard-container-col">
          <Row gutter={[32, 32]}>
            {visibleCards.map((item) => (
              <Col
                xl={6}
                lg={8}
                md={10}
                sm={12}
                xs={12}
                className="cash-booking"
                key={item.key}
              >
                <DashbordCard
                  accountBookingArrowIcon={accountBookingArrowIcon}
                  accountBookingIcon={item.icon}
                  bookingType={item.title}
                  route={item.route}
                  id={item.key}
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default ShipmentStatus;
